import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePicker, DateRange } from '@com-delta-omnichannel/mach-core-js';
import {
  StaysWidget,
  StaysWidgetForm
} from '../../stays-widget/models/stays-widget.interfaces';
import { DateDisplayFormatterService } from './date-display-formatter.service';
import { WidgetEventService } from './widget-event.service';

@Injectable({
  providedIn: 'root'
})
export class DatePickerService {
  private eventService = inject(WidgetEventService);
  private formatter = inject(DateDisplayFormatterService);

  setupDateChangeListener(
    form: FormGroup<StaysWidgetForm>,
    rangeDatePickerInstance: DatePicker,
    content: StaysWidget,
    datPickerId: string,
    onCloseFn?: () => void
  ): void {
    rangeDatePickerInstance.onChange(() => {
      this.updateDateDisplay(
        form,
        rangeDatePickerInstance,
        content,
        datPickerId
      );
    });

    rangeDatePickerInstance.onClose(() => {
      onCloseFn?.();
      if (content.dropDownDateOption.triggerElementId) {
        document
          .getElementById(content.dropDownDateOption.triggerElementId)
          ?.focus();
      }
    });
  }

  updateDateDisplay(
    form: FormGroup<StaysWidgetForm>,
    rangeDatePickerInstance: DatePicker,
    content: StaysWidget,
    datPickerId: string
  ): void {
    const displaySpan = document.getElementById(datPickerId);
    if (!displaySpan) return;

    const selectedDates: DateRange =
      rangeDatePickerInstance?.getSelectedDates();

    if (this.hasValidDates(selectedDates)) {
      const travelerError = this.setMaxDatesError(
        form,
        content,
        'maxDateMismatch'
      );

      this.eventService.emitMaxDatesError(travelerError);

      this.formatter.updateDisplayWithDates(
        displaySpan,
        selectedDates,
        content
      );
      this.eventService.emitDateChange(selectedDates);
      this.eventService.emitDateError();
    } else {
      this.formatter.updateDisplayWithDates(
        displaySpan,
        selectedDates,
        content
      );
      this.eventService.emitDateChange(selectedDates);
    }
    this.eventService.emitErrorCountChange();
  }

  private hasValidDates(dates: DateRange): boolean {
    return !!(
      dates?.start &&
      dates?.end &&
      dates.start.getTime() > 0 &&
      dates.end.getTime() > 0
    );
  }

  setMaxDatesError(
    form: FormGroup<StaysWidgetForm>,
    content: StaysWidget,
    mismatchKey: string
  ): string {
    return form.hasError(mismatchKey)
      ? content?.labels?.maxDatesErrorLabel
      : '';
  }
}
